import Litepicker from "./../litepicker";
import Notify from "./../notify";
(function() {
    var modalObjects = null;


    function loadObjects(location, dates) {

        $("#object-list-order-create-list").load("/themes/ahtilahti/ajax/object_orders.php", { data: { action: "get-object-more", location: location, dates: dates } });
    }

    $("#select-object .select__item").on("click", function() {
        let valArendDAtes = $("#object-period").val();
        if (!valArendDAtes) {
            new Notify("Пожалуйста, укажите срок аренды", "alert");
            return;
        }

        if (!modalObjects) {
            modalObjects = new Foundation.Reveal($("#object-list-order-create"));
        }
        let location = $(this).attr("value");
        if (location) {
            loadObjects(location, valArendDAtes);
            modalObjects.open();
        }

    });


    $("[objects-data-daterangepicker]").each(function() {
        new Litepicker({
            element: this,
            minDate: Date.now(),
            lang: "ru-RU",
            format: "DD.MM.YYYY",
            singleMode: false,
            numberOfMonths: 2,
            numberOfColumns: 2,
            inlineMode: true,
            onSelect: function(date1, date2) {
                if (!$.isEmptyObject(selectedObjects)) {
                    for (let obj in selectedObjects) {
                        delete selectedObjects[obj];
                    }
                }

                if (ids.length) {
                    ids.splice(0, ids.length);
                }
                renderSelectedObjects();

            }

        });
    });
    // Создание заказа с админа
    function emailValidate(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    $("[name='phone']").inputmask({
        mask: "+7 (999) 999-99-99",
    });
    var selectedObjects = {};
    var ids = [];

    $(document).on("change", ".obj-checkboxes", function() {

        let id = $(this).attr("data-id");

        if (this.checked) {
            if ($.inArray(id, ids) == -1 && !selectedObjects[id]) {
                ids.push(id);
                selectedObjects[id] = {
                    name: $(this).siblings("span").text(),
                };
            }
        } else {
            delete selectedObjects[id];
            let index = ids.indexOf(id);
            ids.splice(index, 1);

        }

        renderSelectedObjects();

    });

    function renderSelectedObjects() {
        let html = "";

        if (!$.isEmptyObject(selectedObjects)) {
            html = "<label>Выбранные объекты</label>";
            for (let obj in selectedObjects) {
                let id = obj;
                let name = selectedObjects[obj].name;
                html += "<div class='card'><div class='grid-x grid-padding-x selected-object-item event-line align-middle' data-id='" + id + "'>" +
                    "<div class='cell small-24 medium-10'>" + name + "</div><div class='cell small-24 medium-auto '><button type='button' class='remove-selected-obj button alert no-margin'>Убрать</button></div></div></div>";
            }
            $("#object-selected-list").css({ "margin-bottom": "20px" })
            $("#object-selected-list").html(html);
        } else {

            $("#object-selected-list").empty();
            $("#object-selected-list").css({ "margin-bottom": "0" })
        }

    }

    $(document).on("click", ".remove-selected-obj", function(e) {
        e.preventDefault();
        let id = $(this).closest(".selected-object-item").attr("data-id");
        delete selectedObjects[id];

        let index = ids.indexOf(id);
        ids.splice(index, 1);

        renderSelectedObjects();
    });
    $(".create-order-object").on("submit", function(e) {
        e.preventDefault();

        let formDate = new FormData($("#create-order-object")[0]);
        formDate.append("action", "object-create-order");
        $.each($("input[type='file']"), function(element) {
            $.each($(this)[0].files, function(i, file) {
                formDate.append('file[]', file);
            });

        });


        let data = $(this).serializeArray();
        let res = {};
        let requiredError = false;
        let requiredErrorCheckboxes = false;
        data.forEach((element) => {
            var el = $("[name=" + element.name + "]");
            var required = el.attr("data-required");
            if (required == "Y") {
                if (!element.value.trim() || element.value.trim().length == 0) {
                    el.addClass("callout alert");
                    requiredError = true;
                } else {
                    el.removeClass("callout alert");
                }
            }

        });

        // let dataCheckboxes = $(".obj-checkboxes").serializeArray();
        if (ids.length) {

            // dataCheckboxes.forEach((element) => {
            //     var elem = $("[name=" + element.name + "]");
            //     ids.push(elem.attr("data-id"));
            // });
            // data.push({ name: "objects", value: ids });
            // console.log(data);

            formDate.append('objects', ids);

        } else {
            requiredErrorCheckboxes = true;
            new Notify("Пожалуйста, выберите снаряжение", "alert");
        }


        if (emailValidate($("[name='email']").val())) {
            $("[name='email']").removeClass("callout alert");
        } else {
            requiredError = true;
            $("[name='email']").addClass("callout alert");
        }

        if ($("[name='phone']").inputmask("isComplete")) {
            $("[name='phone']").removeClass("callout alert");
        } else {
            requiredError = true;
            $("[name='phone']").addClass("callout alert");
        }


        if (requiredError) {
            new Notify("Пожалуйста, Заполните обязательные поля", "alert");
        }


        if (!requiredErrorCheckboxes && !requiredError) {
            data.forEach((element) => {
                res[element.name] = element.value;
            });

            $.ajax({
                method: "POST",
                url: "/themes/ahtilahti/ajax/object_orders.php",
                async: false,
                cache: false,
                contentType: false,
                processData: false,

                // data: {
                //     action: "object-create-order",
                //     data: res,
                //     files: formDate,
                // },

                data: formDate,

                success: function(response) {

                    let res;
                    typeof response === "string" ?
                        (res = $.parseJSON(response)) :
                        (res = response);
                    if (res.success) {
                        new Notify("Заказ успешно оформлен", "success");
                        document.location.href = "/arenda/orders/order/" + res.order + "/";
                    } else {
                        new Notify("Ошибка оформления заказа", "alert");
                    }
                },
                error(xhr, status, error) {
                    new Notify(xhr, "alert");
                },
            });

        }

    });


    var allowedExtensionsFiles = [
        '.pdf',
        '.PDF',
        '.PNG',
        '.jpg',
        '.JPG',
        '.png',
        '.JPEG',
        '.jpeg'
    ];

    $(document).on("change", ".upload-scan", function() {

        let fileName = $(this).val().split('/').pop().split('\\').pop();
        let file = fileName.replace(/\.[^/.]+$/, "");
        let resFile = null;
        let endName = file.slice(file.length - 4);
        let startName = file.slice(0, 4);
        let delimiter = fileName.lastIndexOf('.');
        let extension = fileName.substr(delimiter);
        let size = (this.files[0].size / 1000).toFixed(1);


        if ($.inArray(extension, allowedExtensionsFiles) != -1) {

            if (size <= 100) {

                if (file.length > 10) {
                    if (startName == endName) {
                        resFile = startName + extension;
                    } else {
                        resFile = startName + "..." + endName + extension;
                    }

                } else {
                    resFile = fileName;
                }
                let value = resFile;

                if (value) {
                    $(this).closest(".cell").find(".download-file-name").html(value + "&nbsp;&nbsp;&nbsp;<span class='file-close delete-file'><i class='fas fa-times'></i></span>");

                } else {
                    $(this).closest(".cell").find(".download-file-name").html("<span class='text-alert'>Ошибка.</span>");
                    let id = $(this).closest(".cell").find(".upload-scan").attr("id");
                    document.getElementById(id).value = "";
                }

            } else {
                new Notify("Файл не должен превышать 100 КБ", 'alert');
                let id = $(this).closest(".cell").find(".upload-scan").attr("id");
                document.getElementById(id).value = "";
            }

        } else {


            new Notify("Недопустимое расширение файла", 'alert');
            let id = $(this).closest(".cell").find(".upload-scan").attr("id");
            document.getElementById(id).value = "";

        }



    });


    $(document).on("click", ".file-close", function(e) {
        e.preventDefault();
        let id = $(this).closest(".cell").find(".upload-scan").attr("id");
        document.getElementById(id).value = "";
        $(this).closest(".cell").find(".download-file-name").empty();

    });





})(jQuery);